import { FormControl, FormControlLabel, RadioGroup, Radio, SxProps, Typography } from '@mui/material';
import { ChangeEvent } from 'react';

export interface IRadioGroupProps {
    name: string;
    data: Array<{
        value: string | number | boolean;
        label: string;
    }>;
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    size?: 'small' | 'medium';
    selectedValue?: string | number | boolean;
    classes?: SxProps;
}

const RadioGroupComponent = ({ classes, name, size, data, onChange, selectedValue }: IRadioGroupProps) => {
    return (
        <FormControl>
            <RadioGroup name={name} value={selectedValue} onChange={onChange}>
                {data.map((item) => {
                    return (
                        <FormControlLabel
                            key={item.label}
                            value={item.value}
                            control={<Radio key={`radio-${item.value}`} size={size || 'small'} />}
                            label={<Typography sx={classes}>{item.label}</Typography>}
                        />
                    );
                })}
            </RadioGroup>
        </FormControl>
    );
};
export default RadioGroupComponent;
